import React from 'react';
import styled from 'styled-components';
// @ts-ignore
import StarRatings from 'react-star-ratings';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  & > p {
    margin: 0;
  }
`;
interface Props {
  currRating: number;
  active?: boolean;
  changeRating?: (newRating: number) => void;
}

const Rating: React.FC<Props> = ({
  currRating,
  active,
  changeRating,
}) => (
  <Wrapper>
    <StarRatings
      rating={+currRating}
      starRatedColor="gold"
      starDimension={active ? '40px' : '20px'}
      starSpacing="1px"
      changeRating={active ? changeRating : null}
      numberOfStars={5}
      name="rating"
    />
    <div></div>
    <p>{currRating}</p>
  </Wrapper>
);

export default Rating;
